import { PaginatedQueryResult } from '@query/usePaginatedQuery'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { PageSection } from '@ui/components/PageSection'

import { BankAccount } from '@model/BankAccount'
import { DocumentClientAreaDto } from '@model/DocumentClientAreaDto'

import { ScrollToIds } from '@hooks/useScrollToElementIds'

import { UploadedDocumentsWrapper } from './DocumentManagementPage'
import { UploadAdditionalDocuments } from './UploadAdditionalDocuments'
import { UploadedDocuments } from './UploadedDocuments'

interface Props extends PaginatedQueryResult<DocumentClientAreaDto> {
  bankAccounts: BankAccount[]
  setIsPaginationEntrySelected: (isPaginationEntrySelected: boolean) => void
}

export const ActivatedClientDocumentManagementPage: FC<Props> = (props) => {
  const { data, bankAccounts, isLoading, setIsPaginationEntrySelected } = props

  const { t } = useTranslation()

  return (
    <UploadedDocumentsWrapper>
      <PageSection
        title={t('Profile.Uploaded Documents')}
        id={ScrollToIds.UploadedDocumentsHeader}
      />

      <UploadAdditionalDocuments />

      <UploadedDocuments
        documents={data}
        setPageQuery={props.setPageQuery}
        pageQuery={props.pageQuery}
        meta={props.meta}
        forceRefresh={props.forceRefresh}
        setIsPaginationEntrySelected={setIsPaginationEntrySelected}
        bankAccounts={bankAccounts}
        isLoading={isLoading}
      />
    </UploadedDocumentsWrapper>
  )
}
